import { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom"
import Header from "./components/Header" // Updated to .jsx
import Hero from "./components/Hero"
import ContactSection from "./components/ContactSection"
import Footer from "./components/Footer"
import ContactForm from "./components/ContactForm"
import TermsPage from "./components/TermsPage"
import PrivacyPage from "./components/PrivacyPage"
import CMIPage from "./components/CMIPage"
import TipsPage from "./components/TipsPage"
import PatientModal from "./components/PatientModal"
import ProductInfoSection from "./components/ProductInfoSection"
import "./App.css"

function MainApp() {
  const [currentPage, setCurrentPage] = useState("home")
  const [showPatientModal, setShowPatientModal] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home"
    setCurrentPage(path)
  }, [location.pathname])

  const renderPage = () => {
    switch (currentPage) {
      case "contact":
        return <ContactForm onBack={() => navigate("/")} />
      case "terms":
        return <TermsPage onBack={() => navigate("/")} />
      case "privacy":
        return <PrivacyPage onBack={() => navigate("/")} />
      case "cmi":
        return <CMIPage onBack={() => navigate("/")} />
      case "tips":
        return <TipsPage onBack={() => navigate("/products")} />
      case "products":
        return <ProductInfoSection onCMIClick={() => navigate("/cmi")} onTipsClick={() => navigate("/tips")} />
      default:
        return (
          <>
            <Hero />
            <ContactSection
              onHealthcareClick={() => navigate("/contact")}
              onPatientClick={() => setShowPatientModal(true)}
              onCMIClick={() => navigate("/cmi")}
              onTipsClick={() => navigate("/tips")}
            />
          </>
        )
    }
  }

  return (
    <div className="min-h-screen bg-stone-50">
      <Header onHomeClick={() => navigate("/")} />
      <main>{renderPage()}</main>
      <Footer onTermsClick={() => navigate("/terms")} onPrivacyClick={() => navigate("/privacy")} />
      <PatientModal isOpen={showPatientModal} onClose={() => setShowPatientModal(false)} />
    </div>
  )
}

function App() {
  return (
    // <BrowserRouter basename="/tips">
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/products" element={<MainApp />} />
        <Route path="/contact" element={<MainApp />} />
        <Route path="/terms" element={<MainApp />} />
        <Route path="/privacy" element={<MainApp />} />
        <Route path="/cmi" element={<MainApp />} />
        <Route path="/tips" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App